import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFiverrComponent } from './simple-icons-fiverr.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFiverrComponent ],
    exports:      [ SimpleIconsFiverrComponent ],
    bootstrap:    []
})
export class SimpleIconsFiverrModule {}
